'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductListController = function () {
  function ProductListController(authService, accountingService, loadingService, enums, $ngConfirm, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ProductListController);
    this.authService = authService;
    this.accountingService = accountingService;
    this.loadingService = loadingService;
    this.enums = enums;
    this.$ngConfirm = $ngConfirm;
    this.$scope = $scope;

    this.selectOptions = {};
    this.filterParams = {};

    this.$scope.vatRates = [{ id: null, name: 'Please Select' }, { id: '0', name: '0%' }, { id: '13.5', name: '13.5%' }, { id: '23', name: '23%' }];

    this.reset();
  }

  (0, _createClass3.default)(ProductListController, [{
    key: 'reset',
    value: function reset() {
      var ctrl = this;

      this.filterParams.entityId = this.authService.authData.currentLocation.key;
      this.filterParams.title = '';
      this.filterParams.createdBy = '';
      this.filterParams.status = "";

      this.pagination = {
        totalItems: 0,
        currentPage: 1,
        pageSize: 10
      };

      this.filterParams.pageCriteria = {
        pageStart: 0,
        itemsToFetch: this.pagination.pageSize,
        sortExpression: 'created',
        ascending: false
      };

      this.notification = {
        type: 'info',
        msg: ''
      };

      this.listProducts();
    }
  }, {
    key: 'updatePageIndex',
    value: function updatePageIndex() {
      if (this.pagination.currentPage === 1) {
        this.filterParams.pageCriteria.pageStart = 0;
      } else {
        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      }
    }
  }, {
    key: 'updateSort',
    value: function updateSort(fieldName) {
      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
      } else {
        this.filterParams.pageCriteria.sortExpression = fieldName;
        this.filterParams.pageCriteria.ascending = true;
      }

      this.listProducts();
    }
  }, {
    key: 'listProducts',
    value: function listProducts() {
      var ctrl = this;

      ctrl.updatePageIndex();

      ctrl.loadingService.showLoading('productListing', 'Loading Products ...');

      ctrl.accountingService.listProducts(ctrl.filterParams).then(function (response) {
        ctrl.products = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: 'No data to display'
          };
        } else {
          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' products'
          };
        }
      }).catch(function (err) {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching products." + (err.data ? err.data.messageDetail : '')
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('productListing');
      });
    }
  }, {
    key: 'showAddProduct',
    value: function showAddProduct() {
      var _this = this;

      this.$scope.errMsg = '';

      this.$scope.product = {
        productId: null,
        title: null,
        description: null,
        price: null,
        vatRate: null
      };

      this.createDialog = this.$ngConfirm({
        title: 'Add Product',
        contentUrl: 'templates/product/editProductTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              var valid = _this.validateAddProduct();

              if (valid) {
                _this.loadingService.showLoading('productListing', 'Adding product ...');

                _this.accountingService.addProduct(_this.authService.authData.currentLocation.key, _this.$scope.product).then(function (response) {
                  _this.listProducts();
                  _this.createDialog.close();
                }).catch(function (err) {
                  switch (err.status) {
                    case 400:
                      _this.$scope.errMsg = err.data[0].value;
                      break;

                    default:
                      _this.$scope.errMsg = err.data.message;
                      break;
                  }
                }).finally(function () {
                  _this.loadingService.hideLoading('productListing');
                });
              }

              return false;
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'validateAddProduct',
    value: function validateAddProduct() {
      if (this.$scope.product.title === null || this.$scope.product.title === '') {
        this.$scope.errMsg = 'Please enter a title.';
        return false;
      }
      if (this.$scope.product.price === null || this.$scope.product.price === '') {
        this.$scope.errMsg = 'Please enter a price.';
        return false;
      }
      if (this.$scope.product.vatRate === null || this.$scope.product.vatRate === '') {
        this.$scope.errMsg = 'Please select a VAT rate.';
        return false;
      }

      return true;
    }
  }, {
    key: 'editProduct',
    value: function editProduct(productId) {
      var _this2 = this;

      this.$scope.errMsg = '';

      this.accountingService.getProduct(productId).then(function (response) {
        _this2.showEditProduct(response.data);
      });
    }
  }, {
    key: 'showEditProduct',
    value: function showEditProduct(product) {
      var _this3 = this;

      this.$scope.errMsg = '';

      this.$scope.product = product;
      this.$scope.product.vatRate = product.vatRate.toString();

      this.editDialog = this.$ngConfirm({
        title: 'Edit Product',
        contentUrl: 'templates/product/editProductTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              var valid = _this3.validateAddProduct();

              if (valid) {
                _this3.loadingService.showLoading('productListing', 'Updating product ...');

                _this3.accountingService.editProduct(_this3.authService.authData.currentLocation.key, _this3.$scope.product).then(function (response) {
                  _this3.listProducts();
                  _this3.editDialog.close();
                }).catch(function (err) {
                  switch (err.status) {
                    case 400:
                      _this3.$scope.errMsg = err.data[0].value;
                      break;

                    default:
                      _this3.$scope.errMsg = err.data.message;
                      break;
                  }
                }).finally(function () {
                  _this3.loadingService.hideLoading('productListing');
                });
              }

              return false;
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'updateStatus',
    value: function updateStatus(productId, status) {
      var _this4 = this;

      var ctrl = this;
      var title = void 0,
          content = void 0;

      switch (status) {
        case this.enums.OBJECT_ROW_STATE.Active:
          title = 'Activate Product';
          content = 'Are you sure you want to activate this product?';
          break;

        case this.enums.OBJECT_ROW_STATE.Inactive:
          title = 'Suspend Product';
          content = 'Are you sure you want to suspend this product?';
          break;

        case this.enums.OBJECT_ROW_STATE.Deleted:
          title = 'Delete Product';
          content = 'Are you sure you want to delete this product?';
          break;
      }

      this.$ngConfirm({
        title: title,
        content: content,
        type: 'red',
        buttons: {
          confirm: function confirm() {
            ctrl.loadingService.showLoading('productListing', 'Updating product status ...');

            ctrl.accountingService.updateProductStatus(_this4.authService.authData.currentLocation.key, productId, status).then(function (response) {
              ctrl.listProducts();
            }).catch(function (err) {
              switch (err.status) {
                case 400:
                  ctrl.notification = {
                    type: 'error',
                    msg: err.data[0].value
                  };
                  break;

                default:
                  ctrl.notification = {
                    type: 'error',
                    msg: err.data.message
                  };
                  break;
              }
            }).finally(function () {
              ctrl.loadingService.hideLoading('productListing');
            });
          },
          cancel: function cancel() {}
        }
      });
    }
  }]);
  return ProductListController;
}();

exports.default = ProductListController;


// WEBPACK FOOTER //
// ./client/app/components/accounting/productList/productList.controller.js